export let trc20_abi = [
    {
        "inputs": [
            {
                "indexed": true,
                "name": "owner",
                "type": "address"
            },
            {
                "indexed": true,
                "name": "spender",
                "type": "address"
            },
            {
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "Approval",
        "type": "Event"
    },
    {
        "inputs": [
            {
                "indexed": true,
                "name": "delegator",
                "type": "address"
            },
            {
                "indexed": true,
                "name": "fromDelegate",
                "type": "address"
            },
            {
                "indexed": true,
                "name": "toDelegate",
                "type": "address"
            }
        ],
        "name": "DelegateChanged",
        "type": "Event"
    },
    {
        "inputs": [
            {
                "indexed": true,
                "name": "delegate",
                "type": "address"
            },
            {
                "name": "previousBalance",
                "type": "uint256"
            },
            {
                "name": "newBalance",
                "type": "uint256"
            }
        ],
        "name": "DelegateVotesChanged",
        "type": "Event"
    },
    {
        "inputs": [
            {
                "indexed": true,
                "name": "previousOwner",
                "type": "address"
            },
            {
                "indexed": true,
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "OwnershipTransferred",
        "type": "Event"
    },
    {
        "inputs": [
            {
                "indexed": true,
                "name": "from",
                "type": "address"
            },
            {
                "indexed": true,
                "name": "to",
                "type": "address"
            },
            {
                "name": "value",
                "type": "uint256"
            }
        ],
        "name": "Transfer",
        "type": "Event"
    },
    {
        "outputs": [
            {
                "type": "bytes32"
            }
        ],
        "name": "DELEGATION_TYPEHASH",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bytes32"
            }
        ],
        "name": "DOMAIN_TYPEHASH",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "name": "owner",
                "type": "address"
            },
            {
                "name": "spender",
                "type": "address"
            }
        ],
        "name": "allowance",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "spender",
                "type": "address"
            },
            {
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "approve",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "name": "account",
                "type": "address"
            }
        ],
        "name": "balanceOf",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "inputs": [
            {
                "name": "_amount",
                "type": "uint256"
            }
        ],
        "name": "burn",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "name": "fromBlock",
                "type": "uint32"
            },
            {
                "name": "votes",
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "type": "address"
            },
            {
                "type": "uint32"
            }
        ],
        "name": "checkpoints",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint8"
            }
        ],
        "name": "decimals",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "spender",
                "type": "address"
            },
            {
                "name": "subtractedValue",
                "type": "uint256"
            }
        ],
        "name": "decreaseAllowance",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "inputs": [
            {
                "name": "delegatee",
                "type": "address"
            }
        ],
        "name": "delegate",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "inputs": [
            {
                "name": "delegatee",
                "type": "address"
            },
            {
                "name": "nonce",
                "type": "uint256"
            },
            {
                "name": "expiry",
                "type": "uint256"
            },
            {
                "name": "v",
                "type": "uint8"
            },
            {
                "name": "r",
                "type": "bytes32"
            },
            {
                "name": "s",
                "type": "bytes32"
            }
        ],
        "name": "delegateBySig",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "address"
            }
        ],
        "inputs": [
            {
                "name": "delegator",
                "type": "address"
            }
        ],
        "name": "delegates",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "name": "account",
                "type": "address"
            }
        ],
        "name": "getCurrentVotes",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "address"
            }
        ],
        "name": "getOwner",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "name": "account",
                "type": "address"
            },
            {
                "name": "blockNumber",
                "type": "uint256"
            }
        ],
        "name": "getPriorVotes",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "spender",
                "type": "address"
            },
            {
                "name": "addedValue",
                "type": "uint256"
            }
        ],
        "name": "increaseAllowance",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "inputs": [
            {
                "name": "_to",
                "type": "address"
            },
            {
                "name": "_amount",
                "type": "uint256"
            }
        ],
        "name": "mint",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "mint",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "string"
            }
        ],
        "name": "name",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "inputs": [
            {
                "type": "address"
            }
        ],
        "name": "nonces",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint32"
            }
        ],
        "inputs": [
            {
                "type": "address"
            }
        ],
        "name": "numCheckpoints",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "address"
            }
        ],
        "name": "owner",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "name": "renounceOwnership",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "string"
            }
        ],
        "name": "symbol",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "uint256"
            }
        ],
        "name": "totalSupply",
        "stateMutability": "View",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "recipient",
                "type": "address"
            },
            {
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "transfer",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "outputs": [
            {
                "type": "bool"
            }
        ],
        "inputs": [
            {
                "name": "sender",
                "type": "address"
            },
            {
                "name": "recipient",
                "type": "address"
            },
            {
                "name": "amount",
                "type": "uint256"
            }
        ],
        "name": "transferFrom",
        "stateMutability": "Nonpayable",
        "type": "Function"
    },
    {
        "inputs": [
            {
                "name": "newOwner",
                "type": "address"
            }
        ],
        "name": "transferOwnership",
        "stateMutability": "Nonpayable",
        "type": "Function"
    }
]